
export type GetTweetById200Content = {
  mentions?: string[];
  /**
   * @maxLength 280
   * @nullable
   */
  text?: string | null;
};
